import type { Session } from '@/classes/Session'
import { useCloudSyncService } from '@/services/CloudSync/cloudSyncService'
import { Feature, useFeatureService } from '@/services/featureService'
import { useSyncStore } from '@/stores/sync'
import { computed } from 'vue'

export const useCloudSyncStatusCalculation = (session?: Session) => {
	const cloudSyncService = useCloudSyncService()
	const syncStore = useSyncStore()
	const cloudSyncEnabled = useFeatureService().isEnabled(Feature.CloudSync)

	const currentSyncState = computed(() => {
		if (!session || !cloudSyncEnabled) {
			return 'NoSync'
		}

		const hasPendingUpsert = session.planIds.some((id) =>
			cloudSyncService.pendingPlanIds.includes(id)
		)
		// if offline, return 'OfflinePending'
		if (hasPendingUpsert && syncStore.offline) {
			return 'OfflinePending'
		}
		return hasPendingUpsert ? 'Syncing' : 'NoSync'
	})

	return { currentSyncState }
}
